






// let woodenCameraTags = {
//     "ARRI CAMERA ACCESSORY KITS": "ARRI"
//     ,"BLACKMAGIC CINEMA CAMERA ACCESSORY KITS": "Blackmagic Cinema"
//     ,"CANON CAMERA ACCESSORY KITS": "Canon"
//     ,"NIKON CAMERA ACCESSORY KITS": "Nikon"
//     ,"PANASONIC CAMERA ACCESSORY KITS": "Panasonic"
//     ,"RED CAMERA ACCESSORY KITS": "Red"
//     ,"SONY CAMERA ACCESSORY KITS": "Sony"
//     ,"DIRECTOR'S MONITOR CAGES": "Director's Monitor Cages"
//     ,"ACCESSORIES: FOLLOW FOCUS": "Follow Focus"
//     ,"ACCESSORIES: POWER & CABLES": "Power & Cables"
//     ,"ACCESSORIES: SHOULDER RIGS": "Shoulder Rigs"
//     ,"ACCESSORIES: D-BOX": "D-Box"
//     ,"ACCESSORIES: LENS SUPPORT": "Lens Support"
//     ,"ACCESSORIES: MATTEBOX + ZIP BOX": "MatteBox"
//     ,"ACCESSORIES: HANDLES": "Handles"
//     ,"ACCESSORIES: ROD COMPONENTS": "Rod Components"
//     ,"ACCESSORIES: UVF & ULTRA ARM": "UVF & Ultra Arm"
//     ,"ACCESSORIES: UTILITY": "Utility"
//     ,"ACCESSORIES: REPLACEMENT PARTS": "Replacement Parts"
//     ,"ACCESSORIES: MERCHANDISE": "Merchandise"
//     ,"ACCESSORIES: NATO ACCESSORIES": "NATO"
//     ,"ARRI: CABLES (ARRI)": "CABLES"
//     ,"ARRI: POWER (ARRI)": "POWER"
//     ,"ARRI: HANDLES (ARRI)": "HANDLES"
//     ,"ARRI: ARRI ALEXA MINI ACCESSORY KITS": "Alexa Mini"
//     ,"ARRI: ROD COMPONENTS (ARRI)": "Rod Components"
//     ,"ARRI: UTILITY (ARRI)": "Utility"
//     ,"ARRI: EVF MOUNTS (ARRI)": "EVF Mounts"
//     ,"ARRI: POWER & CABLES (ARRI)": "Power Cables"
//     ,"ARRI: ADAPTER BOXES (ARRI)": "Adapter Boxes"
//     ,"ARRI: NEW RELEASES (ARRI)": "New Releases"
//     ,"ARRI: CAMERA SUPPORT (ARRI)": "Camera Support"
//     ,"ARRI: Adapter Boxes (ARRI)": "Adapter Boxes"
//     ,"BLACKMAGIC: CAMERA SUPPORT (BMC)": "Camera Support"
//     ,"BLACKMAGIC: POWER (BMC)": "Power"
//     ,"BLACKMAGIC: UTILITY (BMC)": "Utility"
//     ,"BLACKMAGIC: POWER & CABLES (BMC)": "Power & Cables"
//     ,"BLACKMAGIC: NEW RELEASES (BMC)": "New Releases"
//     ,"BLACKMAGIC: CABLES (BMC)": "Cables"
//     ,"BLACKMAGIC: ROD COMPONENTS (BMC)": "Rod Components"
//     ,"BLACKMAGIC: BLACKMAGIC STUDIO CAMERA ACCESSORY KITS": "BMC Studio"
//     ,"BLACKMAGIC: BLACKMAGIC POCKET CINEMA CAMERA ACCESSORY KITS": "BMC Pocket"
//     ,"BLACKMAGIC: BLACKMAGIC CINEMA CAMERA ACCESSORY KITS": "BMC Cinema"
//     ,"BLACKMAGIC: BLACKMAGIC URSA ACCESSORY KITS": "BMC Ursa"
//     ,"BLACKMAGIC: BLACKMAGIC MICRO CINEMA CAMERA ACCESSORY KITS": "BMC Micro"
//     ,"BLACKMAGIC: BLACKMAGIC URSA MINI ACCESSORY KITS": "BMC Ursa"
//     ,"BLACKMAGIC: BLACKMAGIC POCKET CINEMA CAMERA 4K": "BMC Pocket"
//     ,"BLACKMAGIC: D-BOX": "D-Box"
//     ,"BLACKMAGIC: SIDE PLATE": "Side Plate"
//     ,"BLACKMAGIC: POWER PLATE": "Power Plate"
//     ,"BLACKMAGIC: CAMERA CAGE (BMC)": "Camera Cage"
//     ,"WOODEN CAMERA ADVANCED KIT": "Advanced"
//     ,"WOODEN CAMERA BASE KIT": "Base"
//     ,"WOODEN CAMERA PRO KIT": "Pro"
//   }
  
//   let teradekTags = {
//     "compat-sdi-in": "SDI In"
//     ,"compat-sdi-out": "SDI Out"
//     ,"sdi_cable": "SDI Cable"
//     ,"compat-2pin-in": "2pin In"
//     ,"compat-2pin-out": "2pin Out"
//     ,"2pin_cable": "2pin Cable"
//     ,"300FTRANGE": "300 ft"
//     ,"500FTRANGE": "500 ft"
//     ,"600FTRANGE": "600 ft"
//     ,"1000FTRANGE": "1000 ft"
//     ,"2000FTRANGE": "2000 ft"
//     ,"3000FTRANGE": "3000 ft"
//     ,"3GSDI--LINKED-MALE": "SDI Receiver"
//   }

  
//   let smallHDTags = {
//     "5inch": "5\" Monitor"
//     ,"5.5inch": "5.5\" Monitor"
//     ,"7inch": "7\" Monitor"
//     ,"TXRXSET": "TX/RX Set"
//     ,"1920X1080": "1920x1080"
//     ,"1920X1200": "1920x1200"
//     ,"1280X720": "1280x720"
//   }


var woodenCameraTags = {
}

var teradekTags = {
  "2PIN-POWER-MDR--LINK": "Power Cable"
  ,"4PIN-CAMERA-CABLE--LINK": "Camera Cable"
  ,"4PIN-MOTOR-CABLE--LINKED-FEMALE": "Lens Motor"
  ,"4PIN-MOTOR-CABLE--LINKED-MALE": "MDR"
  ,"4PIN-MOTOR-CABLE--LINK": "Motor Cable"
  ,"STRAIGHT-MOTOR-CABLE--LINKED-MALE": "MDR (Straight Motor Cables)"
  ,"RA-MOTOR-CABLE--LINKED-MALE": "MDR (R/A Motor Cables)"
  ,"RA-MOTOR-CABLE--LINK": "R/A Motor Cable"
  ,"RA-MOTOR-CABLE--LINKED-FEMALE": "Motor (R/A Motor Cables)"
  ,"STRAIGHT-MOTOR-CABLE--LINK": "Straight Motor Cable"
  ,"STRAIGHT-MOTOR-CABLE--LINKED-FEMALE": "Motor (Straight Motor Cables)"
  ,"MONITOR-RECEIVER--DIRECT-LINKED-MALE": "Transmitter"
  ,"MONITOR-RECEIVER--DIRECT-LINKED-FEMALE": "Monitor Receiver"
  ,"LENS-OVERLAY--LINK": "Lens Overlay Cable"
  ,"LENS-OVERLAY--LINKED-MALE": "CTRL.1"
  ,"LENS-OVERLAY--LINKED-FEMALE": "Monitor"
  ,"BOLT--DIRECT-LINKED-MALE": "Transmitter"
  ,"BOLT--DIRECT-LINKED-FEMALE": "Receiver"
  ,"BOLT-SDI--DEADEND-LINK": "SDI Cables"
  ,"BOLT-SDIHDMI--DEADEND-LINK": "SDI & HDMI Cables"
  ,"BOLT-HDMI--DEADEND-LINK": "HDMI Cables"
  ,"COMPAT_BOLT_500": "Bolt 500"
  ,"COMPAT_BOLT_1000": "Bolt 1000"
  ,"COMPAT_BOLT_3000": "Bolt 3000"
}



var smallHDTags = {
}



// var tagMap = {
//   ...woodenCameraTags
//   ,...teradekTags
//   ,...smallHDTags
// };

var tagMap = Object.assign({}, woodenCameraTags, teradekTags, smallHDTags);


